/* DON'T EDIT THIS FILE: edit original and run build again */ import { getConfig } from "../../framework/config/config.ts";

export const getGenericHostRealmPath = (realmPathLabel: string | null) => {
  if (realmPathLabel) {
    return "/r/" + realmPathLabel;
  } else {
    return undefined;
  }
};

export const getRealmHostnameFromPattern = (
  domainPatternForTenantUrls: string,
  realm: string
) => {
  return domainPatternForTenantUrls.replace("%tenant%", realm);
};

export const getRealmUrlParts = (
  realm: string,
  realmPathLabel: string | null,
  configGetter: () => any = getConfig
): {
  protocol: string;
  hostname: string;
  port: string;
  pathname: string | undefined;
} => {
  const {
    tenants,
    domainPatternForTenantUrls,
    firebaseStartPort,
    url,
    genericUrlDefaultRealm,
  } = configGetter();
  const realmConfig = tenants?.[realm];
  if (realmConfig && realmConfig.host) {
    // configs host refers to hostname
    const { host, port = "", secure = true } = realmConfig;
    return {
      protocol: secure ? "https" : "http",
      hostname: host,
      port: port,
      pathname: "",
    };
  }
  if (domainPatternForTenantUrls) {
    // FIXME?: this should be sandbox specific
    return {
      protocol: "http",
      hostname: getRealmHostnameFromPattern(domainPatternForTenantUrls, realm),
      port: firebaseStartPort,
      pathname: "",
    };
  }
  const parsedUrl = new URL(url);
  return {
    protocol: parsedUrl.protocol.replace(/:/g, ""),
    hostname: parsedUrl.hostname,
    port: parsedUrl.port,
    pathname:
      genericUrlDefaultRealm === realm
        ? ""
        : getGenericHostRealmPath(realmPathLabel),
  };
};
